import { render, staticRenderFns } from "./Porezi.vue?vue&type=template&id=be4a5fae&scoped=true&"
import script from "./Porezi.vue?vue&type=script&lang=js&"
export * from "./Porezi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4a5fae",
  null
  
)

export default component.exports